<template>
  <v-container fill-height>
    <v-row justify="center">
      <v-col class="" cols="12" md="12">
        <v-card
          color="blue lighten-4"
          shaped
          class="borderCard mx-auto elevation-24"
          width="500"
        >
          <v-toolbar class="" dark color="primary darken-1">
            <v-toolbar-title>Login Form</v-toolbar-title>
            <v-spacer />
            <v-icon>fas fa-key</v-icon>
          </v-toolbar>
          <v-card-text>
            <v-form autocomplete="off" v-model="isValid" ref="loginForm">
              <v-text-field
                autocomplete="off"
                @keyup.native.enter="OnLogIn"
                prepend-icon="fas fa-user"
                name="UserNameTextFild"
                label="User Name"
                id="UserID"
                :rules="[v => !!v || 'User Name is require']"
                v-model.trim="LoginUser.UserName"
              ></v-text-field>
              <v-text-field
                autocomplete="off"
                @keyup.native.enter="OnLogIn"
                :rules="[v => !!v || 'Password is require']"
                v-model="LoginUser.Password"
                prepend-icon="fas fa-lock"
                name="PasswordTextFild"
                label="Password"
                id="PasswordId"
                :append-icon="showPassword ? 'far fa-eye' : 'far fa-eye-slash'"
                :type="showPassword ? 'text' : 'password'"
                @click:append="showPassword = !showPassword"
              ></v-text-field>

              <p v-html="msg" class="red--text d-flex mt-2 justify-center"></p>
            </v-form>
          </v-card-text>

          <v-card-actions>
            <v-btn
              color="primary"
              dark
              block
              rounded
              :loading="clicked"
              @click="OnLogIn"
              >Log In
              <v-icon right>fas fa-sign-in-alt</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row></v-container
  >
</template>

<script>
export default {
  data() {
    return {
      showPassword: false,
      isValid: false,
      clicked: false,
      msg: "",
      LoginUser: {
        UserName: "",
        Password: "",
        // UserName: "luulu",
        // Password: "123456"
      },
    };
  },

  methods: {
    OnLogIn() {
      this.$store.commit("CLEAR_BRANCHES");
      if (this.$refs.loginForm.validate()) {
        this.clicked = true;
        this.msg = "";
        this.$store
          .dispatch("login", this.LoginUser)
          .then(() => {
            // console.log(User);
            this.clicked = false;
            this.$store.dispatch("SelectAll", {
              url: "/cashTypes",
              MutName: "SaveCashTypes",
            });
            // this.$socket.emit(WS_EVENTS.joinClass, User);
          })
          .catch(err => {
            // console.log(err.response);
            this.clicked = false;
            this.msg = err.response.data;
          });
      } else this.msg = "Enter User name and password";
    },
  },
};
</script>
<style scoped>
.borderCard {
  border: 5px solid black;
  /* border-top: 10px; */
}
</style>
